import { Grid, useMediaQuery, useTheme, Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ShowWithAlphabetItems, nameItems, rowsPerPageItems, viewItems } from './payrollConstants';

import { EnhancedDropDownRHF } from '@websential/cosmic-v20'

interface ICalculatedPayrollSetupHeaderPanel {
    departmentsDDLItems: any;
    calculatedPayrollTableData: any;
    onChangeNameCalculatedFilter: (selected: any) => void;
    ShowWithAlphabetCalculatedFilter: (selected: any) => void;
    onChangeViewFilter: (selected: any) => void;
    onChangeDepartmentsCalculatedFilter: (selected: any) => void;
    onChangeRowsPerPageCalculatedFilter: (selected: any) => void;
    onChangePageCalculatedFilter: (selected: any) => void;
    gridsMaxTotalWidth?: any
    pageSizeCalculatedStored?: any
}
export const CalculatedPayrollSetupHeaderPanel: React.FC<ICalculatedPayrollSetupHeaderPanel> = ({ departmentsDDLItems, calculatedPayrollTableData,

    onChangeNameCalculatedFilter,
    ShowWithAlphabetCalculatedFilter,
    onChangeViewFilter,
    onChangeDepartmentsCalculatedFilter,
    onChangeRowsPerPageCalculatedFilter,
    onChangePageCalculatedFilter,
    gridsMaxTotalWidth,
    pageSizeCalculatedStored
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const isMediumScreen01 = useMediaQuery(theme.breakpoints.between(900, 1200));
	const isMediumScreen1 = useMediaQuery(theme.breakpoints.between(1195, 1550));
	const isMediumScreen2 = useMediaQuery(theme.breakpoints.between(1550, 1660));
	const mobileTabOrScreen = isMobile || isSmallScreen;
	const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen || isMediumScreen01;
    const [pageItems, setPageItems] = useState<
        { label: string; value: number }[]
    >([]);

    useEffect(() => {
        if (calculatedPayrollTableData?.total && calculatedPayrollTableData?.size) {
            const pageSize =
                pageSizeCalculatedStored && pageSizeCalculatedStored !== calculatedPayrollTableData.size
                    ? pageSizeCalculatedStored
                    : calculatedPayrollTableData.size;
            const pageCount = Math.ceil(
                calculatedPayrollTableData.total / pageSize
            );

            const items = Array.from({ length: pageCount }, (_, index) => ({
                label: `Page : ${String(index + 1)}`,
                value: index + 1,
            }));

            setPageItems(items);
        } else {
            setPageItems([]);
        }
    }, [calculatedPayrollTableData, pageSizeCalculatedStored]);
    return (
        <div style={{ width: gridsMaxTotalWidth && gridsMaxTotalWidth !== 0 ? `${gridsMaxTotalWidth}px` : "100%", minWidth: gridsMaxTotalWidth && gridsMaxTotalWidth !== 0 ? `${gridsMaxTotalWidth}px` : "100%", backgroundColor: "#fff" }}>
            {calculatedPayrollTableData && calculatedPayrollTableData.items && calculatedPayrollTableData.items.length === 0 &&
                calculatedPayrollTableData && calculatedPayrollTableData.total === 0 ? <></> : calculatedPayrollTableData && calculatedPayrollTableData.total !== 0 && 
                <Grid
                    container
                    size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                    sx={{
                        background: "#fff",
                        border: "1px solid #e5e7eb",
                        borderBottom: 0,
                        borderRadius: "2px 2px 0 0",
                        padding: "31px 5px 0 5px",
                        // marginTop:"3rem",
                        "& .dropDownWrapper": { marginBottom: "0!important" },
                        "& .dropDownWrapper .dropDownField__menu": { zIndex: "999!important" }
                    }}
                    columnSpacing={2}
                >
                    <Box
                        sx={{
                            position: !mobileTabOrScreen ? "sticky" : "unset",
                            zIndex: 1,
                            left: 6,
                            display: "flex",
                            gap: 2,
                            backgroundColor: "#fff",
                            width: "fit-content",
                        }}
                    >
                    <Grid
                        size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }} sx={{ 
                            maxWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                            minWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                            }}>

                        <EnhancedDropDownRHF
                            selectName="viewCalculated"
                            testId={`viewCalculated`}
                            items={viewItems}
                            selectedItem={"all"}
                            onSelectionChangeHandler={onChangeViewFilter}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }} sx={{ 
                            maxWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                            minWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                            }}>

                        <EnhancedDropDownRHF
                            selectName="nameCalculated"
                            testId={`nameCalculated`}
                            items={nameItems}
                            selectedItem={"firstName"}
                            onSelectionChangeHandler={onChangeNameCalculatedFilter}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }} sx={{ 
                            maxWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                            minWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                            }}>
                        <EnhancedDropDownRHF
                            selectName="ShowWithAlphabetCalculated"
                            testId={`ShowWithAlphabetCalculated`}
                            items={ShowWithAlphabetItems}
                            selectedItem={"all"}
                            onSelectionChangeHandler={ShowWithAlphabetCalculatedFilter}
                        /></Grid>
                    <Grid
                        size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }} sx={{ 
                            maxWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                            minWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                            }}>
                        <EnhancedDropDownRHF
                            selectName="departmentsCalculated"
                            testId={`departmentCalculated`}
                            selectedItem={"all"}
                            onSelectionChangeHandler={onChangeDepartmentsCalculatedFilter}
                            items={departmentsDDLItems ?? []}
                        /></Grid>
                    <Grid
                        size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }} sx={{ 
                            maxWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                            minWidth: isMediumScreen1 ? "9rem" : isMediumScreen01 ? "8rem" : "12rem",
                            }}>
                        <EnhancedDropDownRHF
                            selectName="rowsPerPageItemsCalculated"
                            testId={`rowsPerPageItemsCalculated`}
                            items={rowsPerPageItems}
                            selectedItem={100}
                            onSelectionChangeHandler={onChangeRowsPerPageCalculatedFilter}
                        /></Grid>
                    <Grid
                        size={{ xs: 4, sm: 4, md: 1.5, lg: 1.5, xl: 1.5 }} sx={{ 
                            maxWidth: isMediumScreen1 ? "8rem" : isMediumScreen01 ? "8rem" : "12rem",
                            minWidth: isMediumScreen1 ? "8rem" : isMediumScreen01 ? "8rem" : "12rem",
                            }}>
                        <EnhancedDropDownRHF
                            selectName="page"
                            testId={`pageCalculated`}
                            items={pageItems}
                            selectedItem={calculatedPayrollTableData && calculatedPayrollTableData?.page}
                            onSelectionChangeHandler={onChangePageCalculatedFilter}
                        /></Grid></Box>
                </Grid>}

        </div>
    )
}

